import {
    useCollectionData,
    useCollection,
} from "react-firebase-hooks/firestore";

import { firestore as db, firebaseApp } from "../../firebase";

import { useEffect, useState } from "react";

import { signInWithEmailAndPassword, getAuth } from "firebase/auth";
import * as fsdb from "firebase/firestore";
import styles from "../../styles/Admin.module.css";

import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import UnitModifier from "../../components/UnitModifier";
import UpdatesHolder from "../../components/UpdatesHolder";
import ClassCalendar from "../../components/ClassCalendar";

const auth = getAuth(firebaseApp);

const SignInHolder = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const signIn = () => {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                console.log("User signed in");
            })
            .catch((error) => {
                console.error("Error signing in", error);
            });
    };

    return (
        <div>
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
            />
            <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
            />
            <button onClick={signIn}>Sign In</button>
        </div>
    );
};

const addUpdate = async (title: string, content: string, type: number = 1) => {
    console.log("Adding update", title, content);
    let t = await fsdb.addDoc(
        fsdb.collection(db, "updates_" + (type === 1 ? "calc" : "lindisc")),
        {
            title,
            content,
            createdAt: fsdb.Timestamp.now(),
        }
    );
    console.log(t);
};

const AdminOptions = () => {
    // create a use state to store title and content as updateContent and updateTitle
    const [updateContent, setUpdateContent] = useState("");
    const [updateTitle, setUpdateTitle] = useState("");
    const [classType, setClassType] = useState(1); // 1 = Math 150/151, 2 = Math 254/245
    const [secondaryClassType, setSecondaryClassType] = useState(1); // 1=150, 2=151, 3=254, 4=245

    // Main class name for calendar/announcements
    const className = classType === 1 ? "calc" : "lindisc";

    // UnitModifier prop
    let unitModifierType = "units_calcone";
    if (classType === 1) {
        unitModifierType =
            secondaryClassType === 1 ? "units_calcone" : "units_calc";
    } else {
        unitModifierType =
            secondaryClassType === 3 ? "units_linear" : "units_lindisc";
    }

    let secondaryClassName =
        classType === 1
            ? secondaryClassType === 1
                ? "150"
                : "151"
            : secondaryClassType === 3
            ? "254"
            : "245";

    const { quill, quillRef } = useQuill({
        placeholder: "Type in the announcement message",
        modules: {
            toolbar: [["bold", "italic", "underline", "strike", "link"]],
        },
    });

    let quillHTML = "";

    useEffect(() => {
        document.title = "Math With Maki | Admin";

        if (quill) {
            quill.on("text-change", () => {
                quillHTML = quill.root.innerHTML;
                // console.log(quillHTML);
                setUpdateContent(quillHTML);
            });
        }
    }, [quill, classType]);

    const settingsRef = fsdb.collection(db, "class_settings");


    type ClassSettingsType = Record<string, { default_units: string; current_semester: number; secondary_class_type: number }>;
    const defaultSettings: ClassSettingsType = {
        calc: { default_units: "units_calcone", current_semester: 1, secondary_class_type: 1 },
        lindisc: { default_units: "units_linear", current_semester: 1, secondary_class_type: 3 },
    };
    const [classSettings, setClassSettings] = useState<ClassSettingsType>(defaultSettings);
    const [settingsReloadTrigger, setSettingsReloadTrigger] = useState(0);

    useEffect(() => {
        fsdb.getDocs(settingsRef).then((snapshot) => {
            const newSettings: ClassSettingsType = { ...defaultSettings };
            snapshot.forEach((doc) => {
                if (doc.exists()) {
                    newSettings[doc.id as keyof ClassSettingsType] = doc.data() as { default_units: string; current_semester: number; secondary_class_type: number };
                } else {
                    console.log("No such document!");
                }
            });
            setClassSettings(newSettings);
            // Optionally log
            console.log("Class settings loaded:", newSettings);
        });
    }, [settingsReloadTrigger]);

    return (
        <div className={styles.adminOptions}>
            <div
                style={{
                    position: "absolute",
                    top: "20px",
                    right: "25px",
                    fontSize: "15px",
                }}
            >
                <span>
                    Currently Managing:
                    {classType === 2 ? " Math 254/245" : " Math 150/151"}
                </span>
            </div>
            {/* <h3>Admin Options</h3> */}
            <br></br>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                }}
            >
                <div style={{ display: "flex" }}>
                    <button
                        onClick={() => {
                            setClassType(1);
                            setSecondaryClassType(classSettings.calc.secondary_class_type);
                        }}
                        style={{
                            backgroundColor:
                                classType === 1 ? "lightblue" : "#eee",
                            fontSize: "1.25rem",
                            width: "250px",
                            borderRadius:
                                classType === 1
                                    ? "10px 0px 0px 0px"
                                    : "10px 0px 0px 10px",
                            position: "relative",
                        }}
                    >
                        Math 150/151
                    </button>
                    <button
                        onClick={() => {
                            setClassType(2);
                            setSecondaryClassType(classSettings.lindisc.secondary_class_type);
                        }}
                        style={{
                            backgroundColor:
                                classType === 2 ? "lightblue" : "#eee",
                            fontSize: "1.25rem",
                            width: "250px",
                            borderRadius:
                                classType === 2
                                    ? "0px 10px 0px 0px"
                                    : "0px 10px 10px 0px",
                            position: "relative",
                        }}
                    >
                        Math 254/245
                    </button>
                </div>
                {/* Secondary buttons, only visible when main button is selected */}
                {classType === 1 && (
                    <div
                        style={{
                            display: "flex",
                            marginTop: "-5px",
                            marginLeft: "0px",
                        }}
                    >
                        <button
                            onClick={() => setSecondaryClassType(1)}
                            style={{
                                backgroundColor:
                                    secondaryClassType === 1
                                        ? "lightblue"
                                        : "#eee",
                                fontSize: "1rem",
                                width: "125px",
                                borderRadius: "0px 0px 0px 10px",
                                borderTop: "none",
                                // marginRight: "2px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                            }}
                        >
                            150
                        </button>
                        <button
                            onClick={() => setSecondaryClassType(2)}
                            style={{
                                backgroundColor:
                                    secondaryClassType === 2
                                        ? "lightblue"
                                        : "#eee",
                                fontSize: "1rem",
                                width: "125px",
                                borderRadius: "0px 0px 10px 0px",
                                borderTop: "none",
                                // marginLeft: "2px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                            }}
                        >
                            151
                        </button>
                    </div>
                )}
                {classType === 2 && (
                    <div
                        style={{
                            display: "flex",
                            marginTop: "-5px",
                            marginLeft: "250px",
                        }}
                    >
                        <button
                            onClick={() => setSecondaryClassType(3)}
                            style={{
                                backgroundColor:
                                    secondaryClassType === 3
                                        ? "lightblue"
                                        : "#eee",
                                fontSize: "1rem",
                                width: "125px",
                                borderRadius: "0px 0px 0px 10px",
                                borderTop: "none",
                                // marginRight: "2px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                            }}
                        >
                            254
                        </button>
                        <button
                            onClick={() => setSecondaryClassType(4)}
                            style={{
                                backgroundColor:
                                    secondaryClassType === 4
                                        ? "lightblue"
                                        : "#eee",
                                fontSize: "1rem",
                                width: "125px",
                                borderRadius: "0px 0px 10px 0px",
                                borderTop: "none",
                                // marginLeft: "2px",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
                            }}
                        >
                            245
                        </button>
                    </div>
                )}
            </div>
            <br></br>
            {/* I am creating a view to view unit modules and then modify */}

            {/* Unit Modifier */}
            <div>
                <h3>Modify Units for Math {secondaryClassName}</h3>
                <UnitModifier unitType={unitModifierType} />
            </div>

            <div style={{ marginTop: "20px" }}>
                <button
                    style={{
                        backgroundColor:
                            secondaryClassType === classSettings[className]?.secondary_class_type
                                ? "#ccc"
                                : "#eee",
                        color: "#333",
                        border: "1px solid #bbb",
                        borderRadius: "8px",
                        padding: "8px 18px",
                        fontSize: "1rem",
                        cursor:
                            secondaryClassType === classSettings[className]?.secondary_class_type
                                ? "no-drop"
                                : "pointer",
                        marginBottom: "8px",
                    }}
                    disabled={
                        secondaryClassType === classSettings[className]?.secondary_class_type
                    }
                    onClick={async () => {
                        const docRef = fsdb.doc(settingsRef, className);
                        await fsdb.updateDoc(docRef, {
                            default_units: unitModifierType,
                            current_semester: ((secondaryClassType % 2) ^ 1) + 1,
                            secondary_class_type: secondaryClassType,
                        });
                        console.log("Updated default units to", secondaryClassType, unitModifierType);
                        setSettingsReloadTrigger(t => t + 1);
                    }}
                >
                    {secondaryClassType === classSettings[className]?.secondary_class_type ? "Default Semester: Math " + secondaryClassName : "Set Default Semester to Math " + secondaryClassName}
                </button>
            </div>

            {/* Add Announcement */}
            <div
                style={{
                    display: "flex",
                    maxHeight: "min-content",
                    flexDirection: "row",
                    gap: "20px",
                }}
            >
                <div
                    style={{
                        height: "auto",
                        flexShrink: 0,
                        maxHeight: "min-content",
                    }}
                >
                    <br></br>
                    <h3>Add Announcement</h3>
                    <br></br>
                    <h4>Title</h4>
                    <input
                        type="text"
                        value={updateTitle}
                        onChange={(e) => setUpdateTitle(e.target.value)}
                        style={{
                            width: 500,
                            padding: "7px",
                            marginTop: "7px",
                            marginBottom: "7px",
                        }}
                    />
                    <br></br>

                    <h4>Content</h4>
                    <div style={{ marginTop: "10px", width: 500, height: 300 }}>
                        <div ref={quillRef} />
                    </div>

                    <button
                        onClick={() => {
                            addUpdate(updateTitle, updateContent, classType);
                        }}
                        style={{ marginTop: "75px", width: "125px" }}
                    >
                        Post Announcement
                    </button>
                </div>
                <div
                    style={{
                        maxHeight: "593px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                        overflow: "auto",
                        flexGrow: 0,
                        flexShrink: 1,
                    }}
                >
                    <UpdatesHolder isAdmin={true} page={className} />
                </div>
            </div>
            {/* Modify Calendar */}
            <div>
                <br></br>
                <h3>Modify Calendar</h3>
                <p style={{ color: "#" }}>
                    Click on empty space to add an event. Click on an event to
                    confirm deletion.
                </p>
                <div
                    style={{
                        padding: "10px",
                        height: "75vh",
                        minWidth: "60vw",
                        maxWidth: "1000px",
                    }}
                >
                    <ClassCalendar isAdmin={true} page={className} />
                </div>
            </div>
        </div>
    );
};

const signOut = () => {
    auth.signOut().then(() => {
        console.log("User signed out");
    });
};

const AdminHolder = () => {
    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            if (user) {
                console.log("User is signed in");
                setIsSignedIn(true);
            } else {
                console.log("User is signed out");
                setIsSignedIn(false);
            }
        });
    }, []);

    const [isSignedIn, setIsSignedIn] = useState(false);
    const [classType, setClassType] = useState(1); // 1 = Math 150, 2 = Math 254

    if (isSignedIn) {
        return (
            <div className={styles.adminHolder}>
                <div className={styles.loginDetails}>
                    <b>You are signed in! {auth.currentUser?.email} </b>
                    <button onClick={() => signOut()}>Sign Out</button>
                </div>
                <AdminOptions />
            </div>
        );
    } else {
        return (
            <div className={styles.adminHolder}>
                <div className={styles.loginHolder}>
                    <p>Please Sign In</p>
                    <SignInHolder />
                </div>
            </div>
        );
    }
};

const Admin = () => {
    return (
        <>
            <div className={styles.page}>
                <h2>Admin</h2>
                <AdminHolder />
            </div>
        </>
    );
};

export default Admin;
